import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PredefinedDateRanges from "../../../core/common/datePicker";
import { expenseDetails } from "../../../core/data/json/expenseDetails";
import Table from "../../../core/common/dataTable/index";
import { TableProps } from "antd";
import ReactApexChart from "react-apexcharts";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "antd";
import {
  fetchAllTimeSheetCount,
  fetchAllWorkingHoursMonthly,
  fetchAllEmployeeData
} from "../../../core/data/redux/reports/timesheet_report/timesheet.Action";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import {
  exportToCSV,
  exportToExcel,
} from "../../../core/common/GlobalFunctions/exportTableData";
import { CaretRightOutlined } from "@ant-design/icons";
import type { ColumnsType } from "antd/es/table";

interface EmployeeData {
  key: string;
  employee_name: string;
  PictureURL: string;
  work_date: string;
  project_name: string;
  total_hours: number;
  hours_logged: number;
  deadline: string;
  status: string;
}

interface Props {
  data: EmployeeData[];
}

interface TimeSheetReportProps {
  showOnlyTable?: boolean;
}
const statusClassMap: Record<string, string> = {
  "In Progress": "badge-warning",
  Completed: "badge-success",
  Pending: "badge-secondary",
};

const formatDate = (date: string) =>
  new Date(date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

const detailCellStyle = {
  padding: "8px",
  border: "1px solid #E9EDF4",
  fontSize: "14px",
};


const TimeSheetReport: React.FC<TimeSheetReportProps> = ({showOnlyTable})  => {
  const [countDetails, setcountDetails] = useState<any>(null);
  const [selectedYear, setSelectedYear] = useState("2025");
  const [employeeData, setemployeeData] = useState<any>(null);
  console.log(employeeData, 'employeeData')
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());

  const toggleRow = (employeeName: string) => {
    const updated = new Set(expandedRows);
    if (updated.has(employeeName)) {
      updated.delete(employeeName);
    } else {
      updated.add(employeeName);
    }
    setExpandedRows(updated);
  };


  const dispatch = useDispatch<AppDispatch>();


  useEffect(() => {
    dispatch(fetchAllWorkingHoursMonthly(selectedYear)).then((res) => {
      console.log(res.payload.data);
    });
    dispatch(fetchAllTimeSheetCount()).then((res) => {
      setcountDetails(res.payload.data);
    });
    dispatch(fetchAllEmployeeData())
      .then((res) => {
        setemployeeData(res.payload.data)
      })
  }, []);




  const employeeData2 = employeeData;

  function extractWorkSummary(employeeData: any[] = []) {
  const result: any[] = [];

  for (let i = 0; i < employeeData.length; i++) {
    const employee = employeeData[i];

    // ✅ Default to [] if null/undefined
    const workEntries = Array.isArray(employee?.workEntries) ? employee.workEntries : [];

    for (let j = 0; j < workEntries.length; j++) {
      const entry = workEntries[j];

      result.push({
        employeeName: employee?.employeeName ?? "Unknown",
        projectName: entry?.projectName ?? "N/A",
        workDate: entry?.work_date ? entry.work_date.split("T")[0] : null,
        deadline: entry?.deadline ? entry.deadline.split("T")[0] : null,
        totalHours: parseFloat(entry?.total_hours ?? "0"),
        hoursLogged: parseFloat(entry?.hours_logged ?? "0"),
        status: entry?.status ?? "",
        requestStatus: entry?.requestStatus ?? "",
      });
    }
  }

  return result;
}


const extracted = extractWorkSummary(employeeData || []);

  const data = extracted;




  useEffect(() => {
    dispatch(fetchAllWorkingHoursMonthly(selectedYear)).then((res) => {
      const monthlyData = res.payload.data;

      const workingHoursPerMonth = new Array(12).fill(0);

      if (monthlyData && monthlyData.length > 0) {
        monthlyData.forEach(({ month, total_hours_logged }: any) => {
          const monthIndex = month - 1;
          workingHoursPerMonth[monthIndex] = parseFloat(total_hours_logged);
        });
      }

      setExpensechart((prev: any) => ({
        ...prev,
        series: [
          {
            ...prev.series[0],
            data: workingHoursPerMonth,
          },
        ],
      }));
    });
  }, [selectedYear]);

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };

  const headerStyle = {
    color: "#111827",
    fontWeight: 600,
    background: "#E5E7EB",
    borderBottom: "1px solid #E9EDF4",
    fontSize: "14px",
    padding: "12px", // optional for spacing
    textAlign: "center",
  };

  const columns = [
    {
      title: "",
      dataIndex: "expand",
      width: 50,
    },
    {
      title: "Employee",
      dataIndex: "employee_name",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <Link to="#" className="avatar avatar-md border avatar-rounded">
            <img src={record.PictureURL} className="img-fluid" alt="img" />
          </Link>
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#">{record.employee_name}</Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) =>
        a.employee_name.length - b.employee_name.length,
    },
    {
      title: "Date",
      dataIndex: "work_date",
      render: (text: string) => formatDate(text),
      sorter: (a: any, b: any) => a.work_date.length - b.work_date.length,
    },
    {
      title: "Project",
      dataIndex: "project_name",
      render: (text: String, record: any) => (
        <p className="fs-14 fw-medium text-gray-9 d-flex align-items-center">
          {record.project_name}
        </p>
      ),
      sorter: (a: any, b: any) => a.project_name.length - b.project_name.length,
    },
    {
      title: "Assigned hours",
      dataIndex: "total_hours",
      sorter: (a: any, b: any) => a.total_hours - b.total_hours,
    },
    {
      title: "Worked Hours",
      dataIndex: "hours_logged",
      sorter: (a: any, b: any) => a.hours_logged - b.hours_logged,
    },
    {
      title: "Due Date",
      dataIndex: "deadline",
      render: (text: string) => formatDate(text),
      sorter: (a: any, b: any) => a.deadline.length - b.deadline.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => {
        let badgeClass = "";
        let badgeText = "";
        switch (text) {
          case "Pending":
            badgeClass = "badge-warning";
            badgeText = "Pending";
            break;
          case "In Progress":
            badgeClass = "badge-primary";
            badgeText = "In Progress";
            break;
          case "Completed":
            badgeClass = "badge-success";
            badgeText = "Completed";
            break;
          case "Deleted":
            badgeClass = "badge-danger";
            badgeText = "Deleted";
            break;
          default:
            badgeClass = "badge-secondary";
            badgeText = "Unknown";
        }
        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {badgeText}
          </span>
        );
      },
    },
  ];

  //New Chart
  const [expensechart, setExpensechart] = useState<any>({
    series: [
      {
        name: "Working Hrs",
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      height: 190,
      type: "area",
      zoom: {
        enabled: false,
      },
    },
    colors: ["#FF9F43"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    title: {
      text: "",
      align: "left",
    },
    // grid: {
    //   row: {
    //     colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
    //     opacity: 0.5
    //   },
    // },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      min: 1,
      max: 200,
      tickAmount: 5,
      labels: {
        offsetX: -15,
        formatter: (val: number) => {
          return val / 1 + "Hr";
        },
      },
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  });
if (showOnlyTable) {
  return (
  <div className="card-body p-0">
              <table
                className="custom-table"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead
                  style={{
                    backgroundColor: "#E5E7EB",
                    color: "#111827",
                    fontWeight: 600,
                    fontSize: "14px",
                    padding: "6px",
                  }}
                >
                  <tr>
                    <th style={{ width: "25%" }}>Employee</th>
                    <th>Time Sheet Details</th>
                  </tr>
                </thead>
                <tbody>
                  {employeeData &&
                    employeeData.map((employee: any, index: any) => (
                      <React.Fragment key={employee.employeeName}>
                        <tr
                          style={{
                            backgroundColor: index % 2 === 0 ? "#ffffff" : "#f6f6f6",
                          }}
                        >
                          <td style={{ padding: "10px", verticalAlign: "middle" }}>
                            <CaretRightOutlined
                              onClick={() => toggleRow(employee.employeeName)}
                              rotate={expandedRows.has(employee.employeeName) ? 90 : 0}
                              style={{
                                borderRadius: "50%",
                                border: "1px solid #ddd",
                                cursor: "pointer",
                                marginRight: "8px",
                              }}
                            />
                            <strong>{employee.employeeName}</strong>
                          </td>
                          <td></td>
                        </tr>

                        {expandedRows.has(employee.employeeName) && (
                          <tr>
                            <td></td>
                            <td>
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                <thead>
                                  <tr style={{ backgroundColor: "#E5E7EB" }}>
                                    <th style={{ padding: "6px" }}>Date</th>
                                    <th>Projects</th>
                                    <th>Tasks</th>
                                    <th>Assigned Hours</th>
                                    <th>Worked Hours</th>
                                    <th>Due Date</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {employee.workEntries.map((entry: any) => (
                                    <tr key={entry.work_id}>
                                      <td style={{ padding: "6px" }}>
                                        {entry.work_date.split("T")[0]}
                                      </td>
                                      <td>{entry.project_names}</td>
                                      <td>{entry.task_names}</td>
                                      <td>{entry.total_hours}</td>
                                      <td>{entry.hours_logged}</td>
                                      <td>{entry.deadline.split("T")[0]}</td>
                                      <td>
                                        <span
                                          className={`badge ${statusClassMap[entry.requestStatus] || "badge-secondary"
                                            }`}
                                        >
                                          {entry.requestStatus}
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                </tbody>
              </table>

  </div>
  );
}
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">TimeSheet Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HR</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    TimeSheet Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data, "TimeSheet_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data, "TimeSheet_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            {/* Total Exponses */}
            <div className="col-xl-6 d-flex">
              <div className="row flex-fill">
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/total-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Total Project
                          </span>
                          <h5>{countDetails?.[0].total_projects}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-primary border border-primary"
                        >
                          <span className="text-primary">
                            <i className="ti ti-folders" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/approved-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Completed Projects
                          </span>
                          <h5>{countDetails?.[0].completed_projects}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-success border border-success"
                        >
                          <span className="text-success">
                            <i className="ti ti-layout" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/pending-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            In-Progress Project
                          </span>
                          <h5>{countDetails?.[0].in_progress_projects}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-skyblue border border-skyblue"
                        >
                          <span className="text-skyblue">
                            <i className="ti ti-briefcase" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="card flex-fill position-relative">
                    <span className="position-absolute start-0 bottom-0">
                      <ImageWithBasePath
                        src="assets/img/reports-img/reject-expense.svg"
                        alt="img"
                        className="img-fluid"
                      />
                    </span>
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div>
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Pending Project
                          </span>
                          <h5>{countDetails?.[0].pending_projects}</h5>
                        </div>
                        <Link
                          to="#"
                          className="avatar avatar-md avatar-rounded bg-transparent-danger border border-danger"
                        >
                          <span className="text-danger">
                            <i className="ti ti-layout" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Exponses */}
            {/* Total Exponses */}
            <div className="col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-area-line text-danger" />
                      </span>
                      <h5>TimeSpend</h5>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-2">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2025")}
                          >
                            2025
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2024")}
                          >
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2023")}
                          >
                            2023
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-0">
                  <ReactApexChart
                    id="expense-analysis"
                    options={expensechart}
                    series={expensechart.series}
                    type="area"
                    height={193}
                  />
                </div>
              </div>
            </div>
            {/* /Total Exponses */}
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>TimeSheet List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  {/* <div className="input-icon-end position-relative">
                                        <PredefinedDateRanges />
                                        <span className="input-icon-addon">
                                            <i className="ti ti-chevron-down" />
                                        </span>
                                    </div> */}
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <table
                className="custom-table"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead
                  style={{
                    backgroundColor: "#E5E7EB",
                    color: "#111827",
                    fontWeight: 600,
                    fontSize: "14px",
                    padding: "6px",
                  }}
                >
                  <tr>
                    <th style={{ width: "25%" }}>Employee</th>
                    <th>Time Sheet Details</th>
                  </tr>
                </thead>
                <tbody>
                  {employeeData &&
                    employeeData.map((employee: any, index: any) => (
                      <React.Fragment key={employee.employeeName}>
                        <tr
                          style={{
                            backgroundColor: index % 2 === 0 ? "#ffffff" : "#f6f6f6",
                          }}
                        >
                          <td style={{ padding: "10px", verticalAlign: "middle" }}>
                            <CaretRightOutlined
                              onClick={() => toggleRow(employee.employeeName)}
                              rotate={expandedRows.has(employee.employeeName) ? 90 : 0}
                              style={{
                                borderRadius: "50%",
                                border: "1px solid #ddd",
                                cursor: "pointer",
                                marginRight: "8px",
                              }}
                            />
                            <strong>{employee.employeeName}</strong>
                          </td>
                          <td></td>
                        </tr>

                        {expandedRows.has(employee.employeeName) && (
                          <tr>
                            <td></td>
                            <td>
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                <thead>
                                  <tr style={{ backgroundColor: "#E5E7EB" }}>
                                    <th style={{ padding: "6px" }}>Date</th>
                                    <th>Projects</th>
                                    <th>Tasks</th>
                                    <th>Assigned Hours</th>
                                    <th>Worked Hours</th>
                                    <th>Due Date</th>
                                    <th>Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {employee.workEntries.map((entry: any) => (
                                    <tr key={entry.work_id}>
                                      <td style={{ padding: "6px" }}>
                                        {entry.work_date.split("T")[0]}
                                      </td>
                                      <td>{entry.project_names}</td>
                                      <td>{entry.task_names}</td>
                                      <td>{entry.total_hours}</td>
                                      <td>{entry.hours_logged}</td>
                                      <td>{entry.deadline.split("T")[0]}</td>
                                      <td>
                                        <span
                                          className={`badge ${statusClassMap[entry.requestStatus] || "badge-secondary"
                                            }`}
                                        >
                                          {entry.requestStatus}
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                </tbody>
              </table>

            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default TimeSheetReport;
